import React from 'react';
import { Tag } from 'antd';
import type { PlantingLifecycleStatus } from '../../../models/Planting';
import { PLANTING_STATUS_META } from '../constants';

interface PlantingLifecycleTagProps {
  status?: PlantingLifecycleStatus | null;
  className?: string;
}

const PlantingLifecycleTag: React.FC<PlantingLifecycleTagProps> = ({ status, className }) => {
  if (!status) {
    return <Tag className={className}>Не указан</Tag>;
  }

  const meta = PLANTING_STATUS_META[status];

  return (
    <Tag className={className} color={meta?.color}>
      {meta?.label ?? status}
    </Tag>
  );
};

export default PlantingLifecycleTag;
